import React from 'react';
import { motion } from 'framer-motion';
import { LinkIcon, MicIcon, SparklesIcon, RefreshCwIcon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    id: 1,
    title: 'Connect',
    description: "Your admin connects HubSpot and your meeting platform. That's the only setup required.",
    icon: LinkIcon
  }, {
    id: 2,
    title: 'Record',
    description: 'Kinase automatically ingests call recordings from Zoom. No bot joining required.',
    icon: MicIcon
  }, {
    id: 3,
    title: 'Extract',
    description: 'AI structures BANT, MEDDICC, and deal signals before the next call starts.',
    icon: SparklesIcon
  }, {
    id: 4,
    title: 'Sync',
    description: 'Data flows into HubSpot automatically. Reps never touch the CRM.',
    icon: RefreshCwIcon
  }];
  return <section id="how-it-works" className="py-24 md:py-32 bg-slate-50" data-id="element-229">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <div className="text-xs uppercase tracking-[0.2em] font-medium text-teal-600 mb-4" data-id="element-232">
            How It Works
          </div>
          <h2 className="text-3xl md:text-4xl font-medium text-slate-900" data-id="element-233">
            One-time setup. Permanent autopilot.
          </h2>
        </div>

        {/* Horizontal timeline layout */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-0 relative" data-id="element-234">
          {/* Connecting line — desktop */}
          <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-[1px] bg-slate-200 z-0" data-id="element-235" />

          {steps.map((step, index) => <motion.div key={step.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.5
        }} className="relative flex flex-col items-center text-center px-6 py-8 md:py-0" data-id="element-236">
              {/* Step number circle */}
              <div className="relative z-10 w-16 h-16 rounded-full bg-white border border-slate-200 flex items-center justify-center mb-6" data-id="element-237">
                <span className="text-teal-600 font-medium text-lg" data-id="element-238">
                  {step.id}
                </span>
              </div>

              <h3 className="text-lg font-medium text-slate-900 mb-2" data-id="element-239">
                {step.title}
              </h3>
              <p className="text-sm text-slate-600 font-normal leading-relaxed max-w-[200px]" data-id="element-240">
                {step.description}
              </p>

              {/* Arrow between steps — mobile */}
              {index < steps.length - 1 && <div className="md:hidden my-2 text-slate-300" data-id="element-241">
                  <ArrowRightIcon className="w-4 h-4 rotate-90" data-id="element-242" />
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}